// Reusable brand logo (landscape wordmark with the cube).
// Used in Navbar, Footer, and any other brand placement.
export const LANDSCAPE_LOGO_URL =
  "/brand/startup-unplugged-logo-landscape.jpeg";

export const SQUARE_LOGO_URL =
  "/brand/startup-unplugged-logo-square.jpg";

export const Logo = ({ className = "h-10", testid = "brand-logo" }) => (
  <img
    src={LANDSCAPE_LOGO_URL}
    alt="Startup Unplugged"
    data-testid={testid}
    draggable={false}
    className={`block w-auto ${className}`}
    style={{ objectFit: "contain" }}
  />
);

export const SquareLogo = ({ className = "h-9 w-9", testid = "brand-square-logo" }) => (
  <img
    src={SQUARE_LOGO_URL}
    alt="Startup Unplugged"
    data-testid={testid}
    draggable={false}
    className={`block ${className}`}
    style={{ objectFit: "contain" }}
  />
);
